import { useEffect } from 'react';
import { socket } from '../socket';
import { WsEvents } from '../events';
import { useDispatch } from 'react-redux';
import {
  addLostOrderSuccess,
  updateLostOrderSuccess,
  deleteLostOrderSuccess,
} from '../../store/lostOrders/actions';

export function useLostOrders() {
  const dispatch = useDispatch();

  /**
   * Get All Event Hook
   */
  // useEffect(() => {
  //   function onDataEvent(args) {
  //     // dispatch({
  //     //   type: 'ADD_LOST_ORDER_SUCCESS',
  //     //   payload: {},
  //     // });
  //   }
  //   socket.emit(WsEvents.lostOrders.GET_DATA, onDataEvent);
  // }, []);

  /**
   * Add Event Hook
   */
  useEffect(() => {
    function onAddEvent(res) {
      if ('error' in res) return;
      dispatch(addLostOrderSuccess(res));
    }
    socket.on(WsEvents.lostOrders.ON_ADDED, onAddEvent);

    return () => {
      socket.off(WsEvents.lostOrders.ON_ADDED, onAddEvent);
    };
  }, [dispatch]);

  /**
   * Update Event Hook
   */
  useEffect(() => {
    function onUpdateEvent(res) {
      if ('error' in res) return;
      dispatch(updateLostOrderSuccess(res));
    }
    socket.on(WsEvents.lostOrders.ON_UPDATED, onUpdateEvent);

    return () => {
      socket.off(WsEvents.lostOrders.ON_UPDATED, onUpdateEvent);
    };
  }, [dispatch]);

  /**
   * Delete Event Hook
   */
  useEffect(() => {
    function onDeleteEvent(res) {
      if ('error' in res) return;
      dispatch(deleteLostOrderSuccess(res));
    }
    socket.on(WsEvents.lostOrders.ON_DELETED, onDeleteEvent);

    return () => {
      socket.off(WsEvents.lostOrders.ON_DELETED, onDeleteEvent);
    };
  }, [dispatch]);

  return null;
}
